<!-- input.component.html -->
<div class="form-control">
  <ng-container *ngIf="label">
    <label [for]="inputId" class="text-[var(--black)] font-semibold uppercase">
      {{ label }}
    </label>
  </ng-container>

  <div class="mt-1 relative">
    <input
      [class.border-red-500]="control.invalid && control.touched"
      [type]="isPasswordToggleable ? (showPassword ? 'text' : 'password') : (isCardNumber ? 'text' : type)"
      [id]="inputId"
      [name]="autocomplete || inputId"
      [formControl]="control"
      [autocomplete]="autocomplete"
      [placeholder]="placeholder"
      (input)="isCardNumber ? onCardNumberInput($event) : (filterType === 'name' ? onNameInput($event) : null)"
      (keydown)="isCardNumber ? onCardNumberKeydown($event) : null"
      (keypress)="!isCardNumber ? onKeypress($event) : true"
      (blur)="onBlur()"
      [attr.maxlength]="maxlength || null"
      class="appearance-none block w-full px-5 py-3 border border-[var(--black)] rounded-2xl placeholder-[var(--dark-grey)] focus:outline-none focus:ring-secondary focus:border-secondary font-bold text-[14px]/[14px]"
    />
    <div *ngIf="icon" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
      <fa-icon [icon]="icon" class="text-[var(--grey)]" size="2xl"></fa-icon>
    </div>
    <button *ngIf="type === 'password'" type="button" (click)="togglePassword()" class="absolute inset-y-0 right-0 pr-3 flex items-center z-10 focus:outline-none">
      <fa-icon [icon]="showPassword ? faEyeSlash : faEye" class="text-[var(--grey)]" size="lg"></fa-icon>
    </button>
  </div>

  <ng-container *ngIf="showErrors && control.invalid && control.touched">
    <div *ngFor="let err of control.errors | keyvalue" class="mt-2 font-bold text-[14px]/[14px]" style="color: red;">
      {{ errorMessages[err.key] ? errorMessages[err.key] : 'Hay un error en este campo' }}
    </div>
  </ng-container>
</div>
